/** 各フェーズ定義 */
export const PHASE = {
  START: 'start', // 警告表示
  SELECT: 'select', // 機能選択
  HISTORY_LIST: 'history_list', // 履歴情報表示
  READ: 'read', // 履歴データ読み出し
  SUCCESS: 'success', // 成功表示
  FAILED: 'failed', // 失敗表示
  COMMON_ERROR: 'common_error', // 通信エラー表示
  PARTIAL_FAILED: 'partial_failed', // 一部復号失敗表示
  SAVE_FAILED: 'save_failed', // 保存時復号失敗表示
  INPUT_PASSWORD: 'input_password', // パスワード入力
  CONFIRM_CONSENT: 'confirm_consent', // 同意確認
  PASSWORD_MISMATCH: 'password_mismatch', // パスワード不一致
  PREVIEW_SELECT: 'preview_select', // プレビュー選択
  PREVIEW_INFO: 'preview_info', // プレビュー情報表示
  PREVIEW_DISPLAY: 'preview_display', // プレビュー表示
  PREVIEW_FAILED: 'preview_failed', // プレビュー時復号失敗表示
};

// 特殊キーのenum
const SPWS_KEY_LIST = {
  CTRL_ALT_V: 0
};

// 特殊キーに対応するcode
export const SPWS_KEY_CODE = [{
  key: SPWS_KEY_LIST.CTRL_ALT_V,
  code: [17, 18, 86]
}];

export const IMAGE_SIZE = {
  WIDTH: 672,
  HEIGHT: 160
};